import { useSyncExternalStore } from 'react';

/** Below this width popovers, menus and selects become bottom sheets and dialogs go full screen. */
export const COMPACT_QUERY = '(max-width: 639px)';

function query(): MediaQueryList | null {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(COMPACT_QUERY)
    : null;
}

function subscribe(listener: () => void): () => void {
  const mq = query();
  if (!mq) return () => undefined;
  mq.addEventListener('change', listener);
  return () => mq.removeEventListener('change', listener);
}

/** True below 640 px (phones): overlays substitute sheets and full-screen dialogs. */
export function useIsCompact(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => query()?.matches ?? false,
    () => false,
  );
}

/** Non-hook variant for event handlers. */
export function isCompactViewport(): boolean {
  return query()?.matches ?? false;
}
